(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rs-cards')) {
    customElements.define(
      'rs-cards',
      class RsCards extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.rs-cards__grid');
          this.prev = this.querySelector('[data-rs-cards-prev]');
          this.next = this.querySelector('[data-rs-cards-next]');
          if (!this.prev || !this.next) return;
          this.prev.addEventListener('click', () => this.step(-1));
          this.next.addEventListener('click', () => this.step(1));
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          // The overflow changes with the track's width (a resize across 750px, the editor's
          // device preview) and with its content (editor block changes), so the buttons follow
          // the track's size, not the state measured at load.
          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.track);
          Array.from(this.track.children).forEach((card) => this.resizeObserver.observe(card));
          this.update();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        /** Scrolls by one card (its width plus the gap). */
        step(direction) {
          const card = Array.from(this.track.children).find((child) => child.offsetWidth > 0);
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const distance = card ? card.offsetWidth + gap : this.track.clientWidth;
          const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({ left: direction * distance, behavior: smooth ? 'smooth' : 'auto' });
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.prev.disabled = this.track.scrollLeft <= 1;
          this.next.disabled = this.track.scrollLeft >= max - 1;
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["class-schedule"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rs-schedule-reveal')) {
    customElements.define(
      'rs-schedule-reveal',
      class RsScheduleReveal extends HTMLElement {
        connectedCallback() {
          // Liquid arms the list only with motion on and outside the editor. It reveals once.
          if (!this.classList.contains('is-armed') || this.classList.contains('is-in')) return;
          // With scroll-driven animations CSS ties each row to its scroll position and the timed
          // fallback below never runs (its armed styles do not apply there either). Rows show at
          // once in the theme editor, under reduced motion and without IntersectionObserver.
          if (
            window.CSS?.supports?.('animation-timeline: view()') ||
            window.Shopify?.designMode ||
            window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
            !('IntersectionObserver' in window)
          ) {
            this.classList.remove('is-armed');
            return;
          }

          // A list already in view at load reveals on the observer's first report.
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.observer.disconnect();
              // The next frame, so the start state has been painted before the transitions start.
              this.frame = requestAnimationFrame(() => this.classList.add('is-in'));
            },
            { rootMargin: '0px 0px -10% 0px' },
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          cancelAnimationFrame(this.frame);
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["distance-rule"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rs-distance-rule')) {
    customElements.define(
      'rs-distance-rule',
      class RsDistanceRule extends HTMLElement {
        connectedCallback() {
          // Liquid arms the rule only with motion on and outside the editor. It reveals once.
          if (!this.classList.contains('is-armed') || this.classList.contains('is-in')) return;
          // With scroll-driven animations CSS ties the rule to the scroll position and the timed
          // fallback below never runs (its armed styles do not apply there either). The final
          // state shows in the theme editor, under reduced motion and without IntersectionObserver.
          if (
            window.CSS?.supports?.('animation-timeline: view()') ||
            window.Shopify?.designMode ||
            window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
            !('IntersectionObserver' in window)
          ) {
            this.classList.remove('is-armed');
            return;
          }

          // The count renders its final value hidden; reset it to 0 before showing it.
          this.number = this.querySelector('.rs-distance__digits');
          this.max = Number(this.dataset.max) || 0;
          if (this.number) this.number.textContent = '0';
          this.classList.add('is-reset');

          // The reveal starts when the rule line (a short marker, always reachable) first shows,
          // or when the stops below it do, for a jump that lands past the line. A share of the
          // whole rule would never be reached by a rule taller than the viewport over that share
          // (twelve long stops stacked on a phone). A rule already in view at load reveals on the
          // observer's first report.
          const marks = [this.querySelector('.rs-distance__track'), this.querySelector('.rs-distance__stops')]
            .filter(Boolean);
          if (marks.length === 0) marks.push(this);
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.observer.disconnect();
              // The next frame, so the start state has been painted before the transitions start.
              this.frame = requestAnimationFrame(() => this.run());
            },
            { threshold: 0 },
          );
          marks.forEach((mark) => this.observer.observe(mark));
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          cancelAnimationFrame(this.frame);
        }

        /** Timed fallback: draws the rule (CSS) and runs the count once, in step with the line's 900ms. */
        run() {
          this.classList.add('is-in');
          if (!this.number) return;
          const start = performance.now();
          const tick = (now) => {
            // A frame time can precede start by a fraction of a millisecond.
            const t = Math.min(1, Math.max(0, (now - start) / 900));
            // Ease in and out, close to the line's cubic-bezier(0.6, 0, 0.2, 1).
            const eased = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
            this.number.textContent = String(Math.round(eased * this.max));
            if (t < 1) this.frame = requestAnimationFrame(tick);
          };
          this.frame = requestAnimationFrame(tick);
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rs-hero')) {
    customElements.define(
      'rs-hero',
      class RsHero extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll(':scope > .rs-hero__track > .rs-hero-slide'));
          if (this.slides.length < 2) return;

          this.track = this.querySelector('.rs-hero__track');
          this.dots = Array.from(this.querySelectorAll('[data-rs-hero-dot]'));
          this.pauseButton = this.querySelector('[data-rs-hero-pause]');
          this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.playing = this.dataset.autoplay === 'true' && !reduceMotion && !window.Shopify?.designMode;
          this.hovered = false;
          this.focused = false;
          this.leaveTimers = new Map();

          this.querySelector('[data-rs-hero-prev]')?.addEventListener('click', () => this.show(this.index - 1));
          this.querySelector('[data-rs-hero-next]')?.addEventListener('click', () => this.show(this.index + 1));
          this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.rsHeroDot))));
          this.pauseButton?.addEventListener('click', () => this.setPlaying(!this.playing));

          // Arrow keys work from the carousel controls only. From a link, button or input inside
          // a slide they keep their own meaning: changing the slide there would hide (inert) the
          // focused element and drop keyboard focus to <body>.
          this.controls = this.querySelector(':scope > .rs-hero__controls');
          this.controls?.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.show(this.index - 1);
            } else if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.show(this.index + 1);
            }
          });

          // Rotation pauses while the pointer or keyboard focus is inside (WAI-ARIA carousel
          // pattern). Focus on the pause button itself does not count, so it can restart rotation.
          this.addEventListener('mouseenter', () => {
            this.hovered = true;
            this.schedule();
          });
          this.addEventListener('mouseleave', () => {
            this.hovered = false;
            this.schedule();
          });
          this.addEventListener('focusin', (event) => {
            this.focused = event.target !== this.pauseButton;
            this.schedule();
          });
          this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) this.focused = false;
            this.schedule();
          });

          // Theme editor: selecting a slide block shows that slide and stops rotation.
          this.onBlockSelect = (event) => {
            const index = this.slides.findIndex((slide) => slide.contains(event.target));
            if (index < 0) return;
            this.setPlaying(false);
            this.show(index);
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);

          this.show(this.index);
          this.setPlaying(this.playing);
        }

        disconnectedCallback() {
          clearTimeout(this.timer);
          this.leaveTimers?.forEach((timer) => clearTimeout(timer));
          if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        show(index) {
          const count = this.slides.length;
          this.index = (index + count) % count;
          this.slides.forEach((slide, i) => {
            const active = i === this.index;
            const leaving = !active && slide.classList.contains('is-active');
            slide.classList.toggle('is-active', active);
            slide.inert = !active;
            if (leaving) this.leave(slide);
            else if (active) this.settle(slide);
            slide.querySelectorAll('rs-video').forEach((video) => (active ? video.resume?.() : video.pause?.()));
          });
          this.dots.forEach((dot, i) => {
            if (i === this.index) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          this.schedule();
        }

        /**
         * Keeps a slide that just went inactive visible (is-leaving, see _hero-slide's CSS) while
         * its opacity fades, then lets it hide. Without a fade (reduced motion, the theme editor)
         * it hides at once.
         */
        leave(slide) {
          this.settle(slide);
          const seconds = parseFloat(getComputedStyle(slide).transitionDuration) || 0;
          if (seconds <= 0) return;
          slide.classList.add('is-leaving');
          this.leaveTimers.set(slide, setTimeout(() => slide.classList.remove('is-leaving'), seconds * 1000));
        }

        settle(slide) {
          clearTimeout(this.leaveTimers.get(slide));
          slide.classList.remove('is-leaving');
        }

        setPlaying(playing) {
          this.playing = playing;
          this.track.setAttribute('aria-live', playing ? 'off' : 'polite');
          if (this.pauseButton) {
            this.pauseButton.dataset.state = playing ? 'playing' : 'paused';
            this.pauseButton.setAttribute(
              'aria-label',
              playing ? this.pauseButton.dataset.labelPause : this.pauseButton.dataset.labelPlay,
            );
          }
          this.schedule();
        }

        schedule() {
          clearTimeout(this.timer);
          if (!this.playing || this.hovered || this.focused) return;
          const seconds = Number(this.dataset.interval) || 5;
          this.timer = setTimeout(() => this.show(this.index + 1), seconds * 1000);
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
